export default __webpack_public_path__ + "static/media/gallery-6.8217053e.jpg";